/*
 * Mode tampilan Terang / Gelap / Auto (AzZahra CBT, aplikasi lama). Default: terang.
 * Pilihan disimpan di localStorage 'azcbt_theme' (sama dengan aplikasi baru); atribut <html data-theme>
 * & data-bs-theme dipakai CSS (assets/global/css/az-app.css). Mode awal diterapkan skrip kecil di <head>
 * (main_page.php) sebelum halaman tampil agar tidak berkedip.
 */
(function () {
    var KEY = 'azcbt_theme', MODES = ['light', 'dark', 'auto'];
    var mq = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;
    function baca() { try { var v = localStorage.getItem(KEY); return MODES.indexOf(v) >= 0 ? v : 'light'; } catch (e) { return 'light'; } }
    var mode = baca();
    function terapkan() {
        var gelap = mode === 'dark' || (mode === 'auto' && mq && mq.matches);
        var r = document.documentElement;
        r.setAttribute('data-theme', gelap ? 'dark' : 'light');
        r.setAttribute('data-bs-theme', gelap ? 'dark' : 'light');
        [].forEach.call(document.querySelectorAll('.az-theme-dd'), function (dd) {
            var t = dd.querySelector('.az-theme-toggle');
            t.querySelector('i').className = 'fa ' + LABEL[mode][0];
            t.querySelector('.az-theme-label').textContent = LABEL[mode][1];
            [].forEach.call(dd.querySelectorAll('[data-mode]'), function (a) { a.parentNode.classList.toggle('active', a.getAttribute('data-mode') === mode); });
        });
    }
    window.azSetTheme = function (m) {
        if (MODES.indexOf(m) < 0) return;
        mode = m;
        try { localStorage.setItem(KEY, m); } catch (e) { /* abaikan */ }
        terapkan();
    };
    if (mq) {
        var ubah = function () { if (mode === 'auto') terapkan(); };
        mq.addEventListener ? mq.addEventListener('change', ubah) : mq.addListener(ubah);
    }

    // Dropdown pemilih mode di header, sebelum avatar profil (header dirender AngularJS lewat ng-include).
    // Layar kecil (menu atas Metronic disembunyikan): salinan dropdown di samping tombol menu.
    var LABEL = { light: ['fa-sun-o', 'Terang'], dark: ['fa-moon-o', 'Gelap'], auto: ['fa-adjust', 'Auto'] };
    function buatDropdown(tag, kelas) {
        var el = document.createElement(tag);
        el.className = 'dropdown az-theme-dd ' + kelas;
        var html = '<a href="javascript:;" class="dropdown-toggle az-theme-toggle" title="Mode tampilan" aria-haspopup="true" aria-expanded="false"><i class="fa fa-sun-o"></i><span class="az-theme-label">Terang</span><i class="fa fa-angle-down"></i></a>' +
            '<ul class="dropdown-menu dropdown-menu-right az-theme-menu">';
        MODES.forEach(function (m) {
            html += '<li><a href="javascript:;" data-mode="' + m + '"><i class="fa ' + LABEL[m][0] + '"></i> ' + LABEL[m][1] + '<i class="fa fa-check az-theme-cek"></i></a></li>';
        });
        el.innerHTML = html + '</ul>';
        el.querySelector('.az-theme-toggle').addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            var buka = !el.classList.contains('open');
            tutupSemua();
            if (buka) { el.classList.add('open'); this.setAttribute('aria-expanded', 'true'); }
        });
        [].forEach.call(el.querySelectorAll('[data-mode]'), function (a) {
            a.addEventListener('click', function (e) { e.preventDefault(); window.azSetTheme(a.getAttribute('data-mode')); tutupSemua(); });
        });
        return el;
    }
    function tutupSemua() {
        [].forEach.call(document.querySelectorAll('.az-theme-dd.open'), function (d) {
            d.classList.remove('open');
            var t = d.querySelector('.az-theme-toggle'); if (t) t.setAttribute('aria-expanded', 'false');
        });
    }
    document.addEventListener('click', function (e) { if (!e.target.closest || !e.target.closest('.az-theme-dd')) tutupSemua(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') tutupSemua(); });
    function pasang() {
        var head = document.querySelector('.page-header .page-header-inner');
        if (!head) return;
        var nav = head.querySelector('.top-menu .navbar-nav');
        if (nav && !nav.querySelector('.az-theme-dd')) {
            var avatar = null;
            [].forEach.call(nav.children, function (li) { if (!avatar && li.querySelector('img')) avatar = li; });
            nav.insertBefore(buatDropdown('li', 'az-theme-dd-top'), avatar || null);
            terapkan();
        }
        if (!head.querySelector('.az-theme-dd-mobile')) {
            var tog = head.querySelector('.responsive-toggler');
            head.insertBefore(buatDropdown('div', 'az-theme-dd-mobile'), tog || null);
            terapkan();
        }
    }
    terapkan();
    function mulai() {
        pasang();
        if (window.MutationObserver) new MutationObserver(pasang).observe(document.body, { childList: true, subtree: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mulai); else mulai();
})();
